'use client'

import { Button } from '../button/button'
import { Icon } from '../icon'

import styles from './header.module.scss'

export const HeaderNavButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    className={styles.navButton}
    color="inherit"
    variant="outlined"
    onClick={onClick}
    aria-label="Open site navigation"
  >
    <Icon icon="Menu" size="md" className={styles.icon} />
  </Button>
)
